/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ApplicableTax } from './';
import {
    ApplicableTaxFromJSON,
    ApplicableTaxFromJSONTyped,
    ApplicableTaxToJSON,
} from './';
import type { Currency } from './';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './';
import type { ExpenseProjectInfoResourceDeductibleCategoriesInner } from './';
import {
    ExpenseProjectInfoResourceDeductibleCategoriesInnerFromJSON,
    ExpenseProjectInfoResourceDeductibleCategoriesInnerFromJSONTyped,
    ExpenseProjectInfoResourceDeductibleCategoriesInnerToJSON,
} from './';
import type { TaxRate } from './';
import {
    TaxRateFromJSON,
    TaxRateFromJSONTyped,
    TaxRateToJSON,
} from './';

/**
 * 
 * @export
 * @interface ExpenseProjectInfoResource
 */
export interface ExpenseProjectInfoResource {
    /**
     * 
     * @type {Currency}
     * @memberof ExpenseProjectInfoResource
     */
    currency?: Currency;
    /**
     * 
     * @type {string}
     * @memberof ExpenseProjectInfoResource
     */
    projectSubject: string;
    /**
     * 
     * @type {string}
     * @memberof ExpenseProjectInfoResource
     */
    freelancerCountry?: string;
    /**
     * 
     * @type {string}
     * @memberof ExpenseProjectInfoResource
     */
    freelancerCarriedStatus?: ExpenseProjectInfoResourceFreelancerCarriedStatusEnum;
    /**
     * 
     * @type {Array<TaxRate>}
     * @memberof ExpenseProjectInfoResource
     */
    freelancerTaxes: Array<TaxRate>;
    /**
     * 
     * @type {Array<ApplicableTax>}
     * @memberof ExpenseProjectInfoResource
     */
    applicableTaxes: Array<ApplicableTax>;
    /**
     * The category deductible with rate by country (If the rate is not deductible, it does not appear here).
     * @type {Array<ExpenseProjectInfoResourceDeductibleCategoriesInner>}
     * @memberof ExpenseProjectInfoResource
     */
    deductibleCategories: Array<ExpenseProjectInfoResourceDeductibleCategoriesInner>;
}


/**
 * @export
 */
export const ExpenseProjectInfoResourceFreelancerCarriedStatusEnum = {
    None: 'NONE',
    Carried: 'CARRIED',
    Pending: 'PENDING'
} as const;
export type ExpenseProjectInfoResourceFreelancerCarriedStatusEnum = typeof ExpenseProjectInfoResourceFreelancerCarriedStatusEnum[keyof typeof ExpenseProjectInfoResourceFreelancerCarriedStatusEnum];


/**
 * Check if a given object implements the ExpenseProjectInfoResource interface.
 */
export function instanceOfExpenseProjectInfoResource(value: object): value is ExpenseProjectInfoResource {
    if (!('projectSubject' in value) || value['projectSubject'] === undefined) return false;
    if (!('freelancerTaxes' in value) || value['freelancerTaxes'] === undefined) return false;
    if (!('applicableTaxes' in value) || value['applicableTaxes'] === undefined) return false;
    if (!('deductibleCategories' in value) || value['deductibleCategories'] === undefined) return false;
    return true;
}

export function ExpenseProjectInfoResourceFromJSON(json: any): ExpenseProjectInfoResource {
    return ExpenseProjectInfoResourceFromJSONTyped(json, false);
}

export function ExpenseProjectInfoResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExpenseProjectInfoResource {
    if (json == null) {
        return json;
    }
    return {
        
        'currency': json['currency'] == null ? undefined : CurrencyFromJSON(json['currency']),
        'projectSubject': json['projectSubject'],
        'freelancerCountry': json['freelancerCountry'] == null ? undefined : json['freelancerCountry'],
        'freelancerCarriedStatus': json['freelancerCarriedStatus'] == null ? undefined : json['freelancerCarriedStatus'],
        'freelancerTaxes': ((json['freelancerTaxes'] as Array<any>).map(TaxRateFromJSON)),
        'applicableTaxes': ((json['applicableTaxes'] as Array<any>).map(ApplicableTaxFromJSON)),
        'deductibleCategories': ((json['deductibleCategories'] as Array<any>).map(ExpenseProjectInfoResourceDeductibleCategoriesInnerFromJSON)),
    };
}

export function ExpenseProjectInfoResourceToJSON(value?: ExpenseProjectInfoResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'currency': CurrencyToJSON(value['currency']),
        'projectSubject': value['projectSubject'],
        'freelancerCountry': value['freelancerCountry'],
        'freelancerCarriedStatus': value['freelancerCarriedStatus'],
        'freelancerTaxes': ((value['freelancerTaxes'] as Array<any>).map((v) => TaxRateToJSON(v))),
        'applicableTaxes': ((value['applicableTaxes'] as Array<any>).map((v) => ApplicableTaxToJSON(v))),
        'deductibleCategories': ((value['deductibleCategories'] as Array<any>).map((v) => ExpenseProjectInfoResourceDeductibleCategoriesInnerToJSON(v))),
    };
}

